import React, { useEffect, useRef, useState } from "react";
import apiClient from '../../services/apiClient';

const PayPalButtonComponent = ({ payment }) => {
  const [paypalId, setPaypalId] = useState(null);
  const [sdkReady, setSdkReady] = useState(false);
  const paypalRef = useRef(null);

  const payAmount = Number(payment) || 0;

  // 1️⃣ Fetch user's PayPal ID once
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await apiClient.get(
          `/userdetaila/${JSON.parse(
            localStorage.getItem("user")
          ).user.id}`
        );
        setPaypalId(response.data.usersdetails[0].paypal_id);
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };
    fetchUserData();
  }, []);

  // 2️⃣ Load PayPal SDK once
  useEffect(() => {
    if (!window.paypal) {
      const script = document.createElement("script");
      script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&currency=USD`;
      script.async = true;
      script.onload = () => setSdkReady(true);
      document.body.appendChild(script);
    } else {
      setSdkReady(true);
    }
  }, []);

  // 3️⃣ Initialize PayPal button safely whenever amount changes
  useEffect(() => {
    if (!sdkReady || !paypalId || !paypalRef.current) return;

    // Clear any existing PayPal button to prevent "container removed" error
    paypalRef.current.innerHTML = "";

    const button = window.paypal.Buttons({
      createOrder: (data, actions) => {
        return actions.order.create({
          purchase_units: [
            {
              amount: { value: payAmount.toFixed(2) },
              payee: { email_address: paypalId },
            },
          ],
        });
      },
      onApprove: (data, actions) =>
        actions.order.capture().then((details) => {
          alert(`Transaction completed by ${details.payer.name.given_name}`);
        }),
      onError: (err) => console.error("PayPal Button Error:", err),
    });

    button.render(paypalRef.current);

    // Cleanup on unmount
    return () => {
      if (paypalRef.current) paypalRef.current.innerHTML = "";
    };
  }, [sdkReady, paypalId, payAmount]);

  return (
    <div>
      {!sdkReady && <p>Loading PayPal...</p>}
      <div ref={paypalRef}></div>
    </div>
  );
};

export default PayPalButtonComponent;
